<div *ngIf="!isMobileView" class="inquiry-container">
    <label class="heading ml-2">Enter Details</label>
    <div class="row m-0 mt-3">
        <div class="col-6 pr-2">
            <div class="col-flex">
                <label class="label">Name</label>
                <input class="input" name="userName" placeholder="name" [(ngModel)]="inquiryData.name" (input)="validateInput($event, userName)"
                  #userName="ngModel" pattern="[a-zA-Z ]*"
                  [ngClass]="{'red-error-class' : (isSubmitted && !inquiryData.name) || userName.errors?.pattern}">

                <div *ngIf="inquiryData.name.length && !isValidName" class="invalid-feedback">
                  <p class="text-left">Only alphabets are allowed</p>
                </div>
            </div>
        </div>
        <div class="col-6 pl-2">
            <div class="col-flex">
                <label class="label">Phone</label>
                <input class="input" type="number" placeholder="phone" [(ngModel)]="inquiryData.phoneNumber"
                [ngClass]="{'red-error-class' : isSubmitted && (!inquiryData.phoneNumber || inquiryData.phoneNumber?.toString()?.length<10)}">
            </div>
        </div>
    </div>
    <div class="row m-0 mt-3">
        <div class="col-12 col-flex">
            <label class="label">Email ID</label>
            <input class="input" type="email" placeholder="email" [(ngModel)]="inquiryData.email"
            [ngClass]="{'red-error-class' : isSubmitted && isEmailFieldRequired && !isValidEmail()}">
        </div>
    </div>

    <div class="row m-0 w-100" *ngIf="isFlexfieldEnable">
        <div class="col-6 mt-3" *ngFor="let field of flexFieldData">
            <div class="col-flex">
                <label *ngIf="field.input_type !== 'Toggle'" class="label">{{field.field_name}}</label>

                <input *ngIf="field.input_type == 'Text'" [id]="field.name" class="input" type="text"
                    placeholder="{{field.field_name}}" [(ngModel)]="field.value"
                    [ngClass]="{'red-error-class' : isSubmitted && field.required && !field.value}">

                <input *ngIf="field.input_type == 'Date'" [id]="field.name" class="input" type="date"
                    placeholder="{{field.field_name}}" [(ngModel)]="field.value"
                    [ngClass]="{'red-error-class' : isSubmitted && field.required && !field.value}">

                <input *ngIf="field.input_type == 'Number'" [id]="field.name" class="input" type="number"
                    placeholder="{{field.field_name}}" [(ngModel)]="field.value"
                    [ngClass]="{'red-error-class' : isSubmitted && field.required && !field.value}">

                <div *ngIf="field.input_type == 'Toggle'" class="switch primary-switch">
                    <label class="switch-label">
                        {{field.field_name}}
                      <input class="ml-2" type="checkbox" checked="checked" [(ngModel)]="field.value">
                      <span class="lever ml-2"></span>
                    </label>
                </div>
            </div>
        </div>
    </div>



    <div class="row m-0 mt-3">
        <div class="col-12 col-flex">
            <label class="label">Description</label>
            <textarea class="input" rows="3" placeholder="description" [(ngModel)]="inquiryData.description"></textarea>
        </div>
    </div>
    <div class="row m-0 mt-3 mb-2" *ngIf="showVideoConf">
        <div class="switch primary-switch">
            <label class="switch-label">
                Enable Video Conference
              <input class="ml-2" type="checkbox" checked="checked" [(ngModel)]="inquiryData.videoConf"
                (change)="changeData($event.target.checked)">
              <span class="lever ml-2"></span>
            </label>
          </div>
    </div>
</div>

<div *ngIf="isMobileView" class="inquiry-container">
    <label class="heading ml-2">Enter Details</label>
    <div class="row m-0 mt-3">
        <div class="col-12">
            <div class="col-flex">
                <label class="label">Name</label>
                <input class="input" name="userName" placeholder="name" [(ngModel)]="inquiryData.name" (input)="validateInput($event, userName)"
                  #userName="ngModel" pattern="[a-zA-Z ]*"
                  [ngClass]="{'red-error-class' : (isSubmitted && !inquiryData.name) || userName.errors?.pattern}">

                <div *ngIf="inquiryData.name.length && !isValidName" class="invalid-feedback">
                  <p class="text-left">Only alphabets are allowed</p>
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="col-flex">
                <label class="label">Phone</label>
                <input class="input" type="number" placeholder="phone" [(ngModel)]="inquiryData.phoneNumber"
                [ngClass]="{'red-error-class' : isSubmitted && (!inquiryData.phoneNumber || inquiryData.phoneNumber?.toString()?.length<10)}">
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="col-flex">
                <label class="label">Email ID</label>
                <input class="input" type="email" placeholder="email" [(ngModel)]="inquiryData.email"
                [ngClass]="{'red-error-class' : isSubmitted && isEmailFieldRequired && !isValidEmail()}">
            </div>
        </div>
        <div *ngIf="isFlexfieldEnable" class="w-100">
            <div class="col-12 mt-3" *ngFor="let field of flexFieldData">
                <div class="col-flex">
                    <label *ngIf="field.input_type !== 'Toggle'" class="label">{{field.field_name}}</label>

                    <div *ngIf="field.input_type == 'Toggle'" class="switch primary-switch">
                        <label class="switch-label">
                            {{field.field_name}}
                          <input class="ml-2" type="checkbox" checked="checked" [(ngModel)]="field.value">
                          <span class="lever ml-2"></span>
                        </label>
                    </div>

                    <input *ngIf="field.input_type == 'Text'" [id]="field.name" class="input" type="text"
                        placeholder="{{field.field_name}}" [(ngModel)]="field.value"
                        [ngClass]="{'red-error-class' : isSubmitted && field.required && !field.value}">

                    <input *ngIf="field.input_type == 'Date'" [id]="field.name" class="input" type="date"
                        placeholder="{{field.field_name}}" [(ngModel)]="field.value"
                        [ngClass]="{'red-error-class' : isSubmitted && field.required && !field.value}">

                    <input *ngIf="field.input_type == 'Number'" [id]="field.name" class="input" type="number"
                        placeholder="{{field.field_name}}" [(ngModel)]="field.value"
                        [ngClass]="{'red-error-class' : isSubmitted && field.required && !field.value}">
                </div>
            </div>
        </div>
        <div class="col-12 mt-3">
            <div class="col-flex">
                <label class="label">Description</label>
                <textarea class="input" rows="3" placeholder="description" [(ngModel)]="inquiryData.description"></textarea>
            </div>
        </div>
        <div *ngIf="showVideoConf" class="col-12 mt-3 mb-2">
            <div class="switch primary-switch">
                <label class="switch-label">
                    Enable Video Conference
                  <input class="ml-2" type="checkbox" checked="checked" [(ngModel)]="inquiryData.videoConf"
                      (change)="changeData($event.target.checked)">
                  <span class="lever ml-2"></span>
                </label>
              </div>
        </div>
    </div>
</div>
